module.exports = __webpack_public_path__ + "img/over-done.3aec0606.png";